import APP from 'src/main.js'
import AppRecord from './AppRecord.js'

class ApplicationRecordLog extends AppRecord {
  get record_controller(){
    let controllers = Object.values(this.constructor.employeeStore.controllers)
    let controller = controllers.find(contr => contr.object_name.camelize() === this.record_type)
    return controller || {}
  }
  get recordMetaData(){
    return this.record_controller._description||{}
  }
  get recordTitle(){
    return this.recordMetaData.title||this.record_type
  }
  translateRecordColumnName(col){
    return ((this.recordMetaData.columns||{})[col]||{}).title||col
  }
  get modifiedFields(){
    return Object.keys(this.data||{}).map(key => this.translateRecordColumnName(key)).join(' - ')
  }
  get db_action(){
    return this.constructor.employeeStore.application_log_types.find(logType => logType.name === this.action).label
  }
  get user(){
    return this.constructor.employeeStore.users.find(usr => usr.id === this.user_id)
  }
  get user_name() {
    return (this.user||{}).person_name
  }
}

export default ApplicationRecordLog
